import get from 'lodash/get';
import compact from 'lodash/compact';

export const venueNameCity = (venue) => {
  return compact([
    get(venue, 'name', null),
    get(venue, 'location.city', null)
  ]).join(', ');
};



// WEBPACK FOOTER //
// ./frontend/react/components/edp/eventinfo/eventinfo_utils.js